import React, { useEffect, useState } from "react"
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls"
import { convertM2ToHectareParseFloat, stringFormatting } from "../../../helpers/TextHelper"
import { useDispatch, useSelector } from "react-redux"
import { RowModule } from "../../../../component/atoms/RowModule/RowModule"
import { useFormikContext } from "formik"
import { useTranslation } from "react-i18next"
import { SelectInput, TextInput, UploadComponent } from "../../../../component"
import { UploadIcon } from "../../../../component/atoms/Icons/SVG/upload"
import { resetUrlResponse, uploadAction } from "../../../../redux/actions/MasterDataAction"
import { UPLOAD } from "../../../../constants/InitTypeConstants"
import { VARIABLE_CONSTANT } from "../../../../constants/VariableConstant"
import { REASON, UNIT_STRING } from "../../../../constants/StringConstant"
import { Accordion } from "../../../../component/atoms/Expands"

export const PlantingSessionForm = ({ index, isBulk = false, detail }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { setFieldValue, values, errors, validateForm, touched } = useFormikContext()
  const { General, MasterData, ReportActivity } = useSelector((state) => state)

  const [stateReason, setStateReason] = useState([])
  const [fileAttachments, setFileAttachments] = useState([])
  const [fileName, setFileName] = useState()
  const [sizeFiles, setSizeFiles] = useState(0)

  const onChangeFileUpload = (e) => {
    setFileAttachments([e])
    setSizeFiles(e.size)
    setFileName(e.name)
    dispatch(uploadAction({ data: e, type: UPLOAD.BUSINESS_DOCUMENT }))
  }

  const onRemove = () => {
    setFileAttachments([])
    setFieldValue(`area.${index}.document_url`, null)
    setFieldValue(`area.${index}.document_name`, null)
    setFieldValue(`area.${index}.document_size`, null)
  }

  // Header Information Component
  const HeaderInfo = ({ detail }) => (
    <div className={`d-flex flex-column bg-white ${isBulk ? "p-4" : "px-4"}`} style={{ gap: 12 }}>
      <div className="d-flex txt-16" style={{ gap: 12 }}>
        <div className="font-weight-bold">{stringFormatting(detail?.land_name)}</div>
        <div>({stringFormatting(detail?.hst.toString(), "HST")})</div>
      </div>
      <div className="d-flex align-items-center txt-14 text-neutral-gray" style={{ gap: 12 }}>
        <div>
          {stringFormatting(convertM2ToHectareParseFloat(detail?.land_area), UNIT_STRING.HA)}
        </div>
        <div className="flag-innactive-sm" />
        <div>{stringFormatting(detail?.farmer_name)}</div>
        <div className="flag-innactive-sm" />
        <div>
          {stringFormatting(detail?.plant_type)} ({stringFormatting(detail?.variety)})
        </div>
      </div>
    </div>
  )

  // Form Fields Component
  function FormFields() {
    return (
      <div className="p-4">
        <RowModule customColumnCss="mb-5 col-lg-12 col-sm-12 col-md-12">
          <SelectInput
            name={`area.${index}.reason_id`}
            editable={true}
            label={t("label_reasons_for_confirm_planting_season")}
            placeholder={t("placeholder_choose_one")}
            options={stateReason}
            value={values.area[index]?.reason_id}
            required={true}
            onChange={(values) => {
              if (values !== REASON.OTHER_PLANTING_SEASON) {
                setFieldValue(`area.${index}.other_reason`, null)
              }

              validateForm()
              setTimeout(() => {
                validateForm()
              }, 100)
            }}
          />
        </RowModule>

        {values.area[index]?.reason_id === REASON.OTHER_PLANTING_SEASON && (
          <RowModule>
            <TextInput
              editable={true}
              name={`area.${index}.other_reason`}
              label={t("label_other_reason")}
              placeholder={t("placeholder_other_reason")}
              required
              value={values.area[index]?.other_reason}
              errorMessage={
                touched.area?.[index]?.other_reason ? errors.area?.[index]?.other_reason : ""
              }
              withoutFeedback={true}
            />
          </RowModule>
        )}

        <RowModule customColumnCss="col-lg-12 col-sm-12 col-md-12" customSeparator="my-0">
          <UploadComponent
            required={true}
            className={"mb-2"}
            label={t("label_event_news_document")}
            name={`area.${index}.document_name`}
            onDeleteFileList={onRemove}
            fileList={fileAttachments}
            typeUpload={"pdf"}
            editable={true}
            onChange={onChangeFileUpload}
            placeholder={<UploadIcon />}
            maxSize={VARIABLE_CONSTANT.MAX_FILE_UPLOAD_PDF}
            maxSizeText={VARIABLE_CONSTANT.MAX_SIZE_PDF}
          />
        </RowModule>

        <div>
          {t("attachment_maximum_text")} {VARIABLE_CONSTANT.MAX_SIZE_PDF}.
        </div>
      </div>
    )
  }

  useEffect(() => {
    if (detail) {
      setFieldValue(`area.${index}.planting_season_id`, detail?.planting_season_id)
    }
  }, [detail])

  useEffect(() => {
    if (ReportActivity.listChildReason.length > 0) {
      setStateReason(
        ReportActivity.listChildReason[0].map((value) => ({
          value: value.id,
          label: value.name
        }))
      )
    }
  }, [ReportActivity.listChildReason])

  useEffect(() => {
    if (MasterData.urlResponseUpload) {
      if (!General.loading) {
        if (MasterData.uploadType === UPLOAD.BUSINESS_DOCUMENT) {
          setFieldValue(`area.${index}.document_url`, MasterData.urlResponseUpload)
          setFieldValue(`area.${index}.document_name`, fileName)
          setFieldValue(`area.${index}.document_size`, sizeFiles)

          setTimeout(() => {
            validateForm()
          }, 100)
        }
      }

      setTimeout(() => {
        dispatch(resetUrlResponse())
      }, 200)
    }
  }, [MasterData.urlResponseUpload, General.loading, MasterData.uploadType])

  // Bulk Mode - Accordion View
  if (isBulk) {
    return (
      <div>
        <Accordion
          items={[
            {
              header: <HeaderInfo detail={detail} />,
              content: FormFields()
            }
          ]}
          borderHeader
          toggleClassName="mr-6"
        />
      </div>
    )
  }

  // Single Mode - Card View
  return (
    <div>
      <Card>
        <CardHeader>
          <HeaderInfo detail={detail} />
        </CardHeader>
        <CardBody>{FormFields()}</CardBody>
      </Card>
    </div>
  )
}
